module.exports = __webpack_public_path__ + "Roboto-Regular-webfont.1d45bc40211734dc3226.svg";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/assets/fonts/roboto/Roboto-Regular-webfont.svg
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Regular-webfont.svg
// module chunks = 2